import qs from 'qs'
import { preview } from 'api/index'
import { getUrlParam } from 'common/js/common'
export default {
  created() {
    const testData = getUrlParam('tData')
    if (testData) {
      let params
      try {
        params = JSON.parse(testData)
      } catch (err) {
        logger.warn('[Mgmt Test data]', err)
      }
      appBridge.hideLoading()
      this.previewData(params)
      return
    }
  },
  methods: {
    // 后台预览数据
    previewData(params) {
      preview(
        qs.stringify({
          jd: JSON.stringify(params)
        })
      ).then(({ data, success } = {}) => {
        success && this.matchData(data)
      })
    }
  }
}
